import { render, staticRenderFns } from "./AreaRanking.vue?vue&type=template&id=dc7ab8f4&scoped=true"
import script from "./AreaRanking.vue?vue&type=script&lang=js"
export * from "./AreaRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7ab8f4",
  null
  
)

export default component.exports